import { FastField } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import { useTranslation } from 'react-i18next';
import { Row, Col, Modal } from 'react-bootstrap';
import KTRadio, { KTRadioType } from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import Utils from 'general/utils/Utils';

function PremiseRentalPriceView({
    formikProps,
    isRentalPriceTypeDisabled = true,
}) {
    const { t } = useTranslation();

    return (
        <Row>
            <Col md={12}>
                <Modal.Title className="mb-3">
                    <span
                        className="font-weight-bolder"
                        style={{ fontSize: 18, color: AppColors.gray[900] }}
                    >
                        Phí thuê mặt bằng
                    </span>
                </Modal.Title>
            </Col>
            <Col md={12}>
                <KTFormGroup
                    label=""
                    inputName="rentalPriceType"
                    additionalLabelClassName="w-160px"
                    additionalClassName="mb-0 d-flex"
                    inputElement={
                        <div className="radio-inline w-100">
                            <FastField name="rentalPriceType">
                                {({ field, form, meta }) => (
                                    <div className="d-flex gap-5">
                                        <KTRadio
                                            name={'Chi phí thuê kết hợp'}
                                            checked={field.value === 'Chi phí thuê kết hợp'}
                                            label={'Chi phí thuê kết hợp'}
                                            type={KTRadioType.outline}
                                            additionalClassName="radio-success"
                                            onChange={() => {
                                                form.setFieldValue(field.name, 'Chi phí thuê kết hợp');
                                            }}
                                            enableCheckValid
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                            disabled={isRentalPriceTypeDisabled}
                                        />
                                        <KTRadio
                                            name={'Phí thuê cố định'}
                                            checked={field.value === 'Phí thuê cố định'}
                                            label={'Phí thuê cố định'}
                                            type={KTRadioType.outline}
                                            additionalClassName="radio-success"
                                            onChange={() => {
                                                form.setFieldValue(field.name, 'Phí thuê cố định');
                                            }}
                                            enableCheckValid
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                        />
                                        <KTRadio
                                            name={'Chia sẻ doanh thu điện'}
                                            checked={field.value === 'Chia sẻ doanh thu điện'}
                                            label={'Chia sẻ doanh thu điện'}
                                            type={KTRadioType.outline}
                                            additionalClassName="radio-success"
                                            onChange={() => {
                                                form.setFieldValue(field.name, 'Chia sẻ doanh thu điện');
                                            }}
                                            enableCheckValid
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                            disabled={isRentalPriceTypeDisabled}
                                        />
                                    </div>
                                )}
                            </FastField>
                        </div>
                    }
                />
            </Col>
            {(formikProps.values.rentalPriceType === 'Chi phí thuê kết hợp' || formikProps.values.rentalPriceType === 'Chia sẻ doanh thu điện') && (
                <>
                    <Col md={12} >
                        <div className="mt-2 mb-4" style={{ borderBottom: `1px dashed ${AppColors.gray[300]}` }} />
                    </Col>
                    <Col md={6}>
                        <KTFormGroup
                            label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Mức chia sẻ theo kW điện')} </span>}
                            inputName="energyCommissionValue"
                            additionalClassName="mb-0"
                            inputElement={
                                <FastField name="energyCommissionValue">
                                    {({ field, form, meta }) => (
                                        <KTFormInput
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => form.setFieldValue(field.name, value)}
                                            onBlur={() => form.setFieldTouched(field.name, true)}
                                            enableCheckValid
                                            type={KTFormInputType.currency}
                                            placeholder={t('enterNumber')}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                            unit='VNĐ/kWh'
                                        />
                                    )}
                                </FastField>
                            }
                            isRequired={true}
                        />
                    </Col>
                </>
            )}
            {(formikProps.values.rentalPriceType === 'Chi phí thuê kết hợp' || formikProps.values.rentalPriceType === 'Phí thuê cố định') && (
                <>
                    <Col md={12} >
                        <div className="mt-4 mb-4" style={{ borderBottom: `1px dashed ${AppColors.gray[300]}` }} />
                    </Col>
                    <Col md={6} className={`pr-lg-2 pr-md-2 pr-0`}>
                        <KTFormGroup
                            label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Số tiền cố định')} </span>}
                            inputName="fixEnergyCommissionValue"
                            additionalClassName=" mb-0"
                            inputElement={
                                <FastField name="fixEnergyCommissionValue">
                                    {({ field, form, meta }) => (
                                        <KTFormInput
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => form.setFieldValue(field.name, value)}
                                            onBlur={() => form.setFieldTouched(field.name, true)}
                                            enableCheckValid
                                            type={KTFormInputType.currency}
                                            placeholder={t('enterNumber')}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                            unit={formikProps.values.rentingType === 'FULL' ? 'VNĐ/tháng' : 'VNĐ/chỗ đỗ/tháng'}
                                        />
                                    )}
                                </FastField>
                            }
                            isRequired={true}
                        />
                    </Col>
                    <Col md={6} className="pl-lg-2 pl-md-2 pl-0">
                        <KTFormGroup
                            label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Ngày bắt đầu tính phí thuê')}</span>}
                            inputName="startDate"
                            additionalClassName=" mb-0"
                            inputElement={
                                <FastField name="startDate">
                                    {({ field, form, meta }) => (
                                        <KTFormInput
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => form.setFieldValue(field.name, value)}
                                            onBlur={() => form.setFieldTouched(field.name, true)}
                                            enableCheckValid
                                            type={KTFormInputType.date}
                                            placeholder={'DD/MM/YYYY'}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                            // maxTime={new Date().toISOString()}
                                            rows={5}
                                            additionalInputClassName="pr-3"
                                        />
                                    )}
                                </FastField>
                            }
                            isRequired={true}
                        />
                    </Col>
                </>
            )}
        </Row>
    )
}

export default PremiseRentalPriceView;